import { buildCssClassName } from "@/3514/utils"

export default {
    components: {
        accountsList: (): string =>
            buildCssClassName(
                "flex",
                "flex-col",
                "md:[display:grid]",
                "md:[grid-template-columns:repeat(auto-fit,290px)]",
                "gap-[20px]",
                "items-center",
                "justify-center",
                "w-full"
            )
    },
    calendarAccounts: {
        container: (): string =>
            buildCssClassName(
                "flex",
                "flex-col",
                "gap-y-[35px]",
                "md:max-w-[660px]",
                "lg:max-w-[720px]",
                "w-full",
                "self-start",
                "pb-[100px]",
                "px-[15px]",
                "md:px-[30px]",
                "lg:px-[60px]",
                "pt-[20px]",
                "md:pt-[10px]"
            ),
        headingWrapper: (): string => "flex flex-col gap-y-[5px]"
    },
    calendarAvailability: {
        container: (): string =>
            buildCssClassName(
                "flex",
                "flex-col",
                "gap-y-[35px]",
                "md:max-w-[660px]",
                "lg:max-w-[720px]",
                "w-full",
                "self-start",
                "pb-[100px]",
                "px-[15px]",
                "md:px-[30px]",
                "lg:px-[60px]"
            ),
        headingWrapper: (): string => "flex flex-col gap-y-[5px]",
        buttonWrapper: (): string => "flex flex-col gap-y-[15px]"
    },
    calendarSetup: {
        container: (): string =>
            buildCssClassName(
                "flex",
                "flex-col",
                "gap-y-[35px]",
                "md:max-w-[850px]",
                "w-full",
                "self-center",
                "pb-[100px]",
                "px-[15px]",
                "md:px-[30px]",
                "lg:px-[60px]"
            ),
        headingWrapper: (): string => "flex flex-col gap-y-[5px]",
        calendarWrapper: (): string => "flex flex-col gap-y-[20px]",
        buttonWrapper: (): string => "flex flex-col gap-y-[15px]"
    },
    linkAccounts: {
        container: (): string =>
            buildCssClassName(
                "flex",
                "flex-col",
                "px-[15px]",
                "md:px-[30px]",
                "lg:px-[0px]",
                "pb-[100px]",
                "md:pb-[200px]",
                "mt-[30px]",
                "lg:mt-0",
                "mx-auto",
                "lg:max-w-[800px]",
                "w-full",
                "h-full"
            ),
        middleContainer: (): string => "flex flex-col items-center gap-y-[30px] mb-[80px]",
        textWrapper: (): string => "flex flex-col items-center gap-y-[10px]",
        link: (): string => "mx-auto"
    },
    relinkAccounts: {
        container: {
            section: buildCssClassName(
                "flex",
                "flex-col",
                "gap-y-[60px]",
                "w-full",
                "max-w-[800px]",
                "mx-auto",
                "mt-[50px]",
                "px-[30px]",
                "lg:px-0",
                "pb-[100px]",
                "md:pb-[200px]"
            )
        },
        components: {
            title: { wrapper: "flex flex-col gap-y-[5px]" },
            itemsBlock: {
                container: "flex flex-col gap-y-[5px]",
                title: "!mb-0",
                list: "flex flex-col w-full",
                listItem: "h-[60px] flex items-center justify-between gap-x-[30px] border-b-[2px] border-gray-500",
                listItemName: "max-w-[140px] truncate sm:max-w-[100%]",
                listButtonWrapper: "flex items-center gap-x-[7px]",
                listItemStatusWrapper: "flex items-center gap-x-[7px]",
                loader: "my-[20px]"
            },
            verify: {
                container: "flex flex-col gap-y-[20px] rounded-[20px] bg-blue-600 py-[25px]",
                textWrapper: "flex flex-col",
                titleText: "mb-[3px]",
                link: "flex gap-x-[5px] items-center self-center"
            }
        }
    },
    accountDeactivationModal: {
        modalBody: buildCssClassName([
            "w-[90%]",
            "md:w-full",
            "md:max-w-fit",
            "py-[35px]",
            "px-[30px]",
            "h-auto",
            "min-h-[200px]",
            "bg-white",
            "rounded-[10px]",
            "flex",
            "flex-col"
        ]),
        modalHeader: "max-w-[80%] self-center",
        contentContainer: "flex flex-col gap-y-[10px] mt-[8px]",
        buttonSet: buildCssClassName([
            "flex",
            "flex-col",
            "md:flex-row",
            "items-center",
            "justify-center",
            "p-[20px]",
            "gap-y-[10px]",
            "md:gap-y-[10px]",
            "md:gap-x-[10px]"
        ]),
        warning: "mt-[15px] max-w-[80%] mx-auto"
    },
    skipRelinkingModal: {
        modalBody: buildCssClassName([
            "w-[90%]",
            "md:w-full",
            "md:max-w-[440px]",
            "py-[35px]",
            "px-[30px]",
            "h-full",
            "max-h-[250px]",
            "min-h-fit",
            "bg-white",
            "rounded-[10px]",
            "flex",
            "flex-col"
        ]),
        contentContainer: "flex flex-col gap-y-[30px] mt-[8px]",
        buttonSet: buildCssClassName([
            "flex",
            "flex-col",
            "md:flex-row",
            "items-center",
            "justify-center",
            "gap-y-[10px]",
            "md:gap-y-[10px]",
            "md:gap-x-[10px]"
        ]),
        button: "max-w-[33%] md:max-w-[140px] min-w-fit w-full"
    }
}
